module.exports = __webpack_public_path__ + "static/assets/e4cca103773478b558ca80f1756705f2.png";